/* eslint-disable @typescript-eslint/camelcase */

let centralUrl = '';
switch (window.location.host) {
	case 'control.livingasone.com':
		centralUrl = 'https://central.livingasone.com';
		break;
	case 'int-control.resi.io':
		centralUrl = 'https://int-central.resi.io';
		break;
	case 'int-control.livingasone.com':
		centralUrl = 'https://int-central.livingasone.com';
		break;
	case 'prod-control.resi.io':
	case 'prod-control.livingasone.com':
		centralUrl = 'https://prod-central.resi.io';
		break;
	case 'control.resi.io':
	default:
		centralUrl = 'https://central.resi.io';
}

const centralBaseUrl = centralUrl;

let mediaStatusUrl = '';
switch (window.location.host) {
	case 'control.livingasone.com':
		mediaStatusUrl = 'https://media-status.livingasone.com';
		break;
	case 'int-control.livingasone.com':
		mediaStatusUrl = 'https://int-media-status.livingasone.com';
		break;
	case 'int-control.resi.io':
		mediaStatusUrl = 'https://int-media-status.resi.io';
		break;
	case 'control.resi.io':
	default:
		mediaStatusUrl = 'https://media-status.resi.io';
}

const mediaStatusBaseUrl = mediaStatusUrl;

let ytClientId = '';
let ytClientSecret = '';
switch (window.location.host) {
	case 'int-control.resi.io':
		ytClientId = '526066391594-l392j3vgcrbhlkjv67v7qnpcut3q41if.apps.googleusercontent.com';
		ytClientSecret = '2xdtL_JVS-CWc3e0hCX67Iyn';
		break;
	case 'control.resi.io':
	default:
		ytClientId = '526066391594-mrhc2863mm1uarsq368auq13erl5pl9n.apps.googleusercontent.com';
		ytClientSecret = 'meKdI1vV_JzKxUK8z5G0DpbZ';
}

export const youtubeClientId = ytClientId;
export const youtubeClientSecret = ytClientSecret;

let onboardingUrl = '';
switch (window.location.host) {
  case 'control.livingasone.com':
    onboardingUrl = 'https://onboarding.livingasone.com';
    break;
  case 'int-control.livingasone.com':
    onboardingUrl = 'https://int-onboarding.livingasone.com';
    break;
  case 'int-control.resi.io':
    onboardingUrl = 'https://int-onboarding.resi.io';
    break;
  case 'control.resi.io':
  default:
    onboardingUrl = 'https://onboarding.resi.io';
}

const onboardingBaseUrl = onboardingUrl;

export const api = {
	url: `${centralBaseUrl}/api_v2.svc`,
	url_v3: `${centralBaseUrl}/api/v3`,
	login_url: `${centralBaseUrl}/api/v3`,
	internal_url: `${centralBaseUrl}/internal/api/v1`,
};

export const mediaStatusApi = {
	v1: `${mediaStatusBaseUrl}/api/v1`,
};

export const onboardingApi = {
	v1: `${onboardingBaseUrl}/api/v1`,
};

export const shaka = {
	v24: '2.4.6',
	v30: '3.0.5',
};

export const google_charts_url = 'https://www.gstatic.com/charts/loader.js';
export const perms = {

	'la1only': 'deleteCustomers',

	'dashboard.get': 'getDashboard',
	'dashboard.multisite.get': 'getMultisiteDashboard',

	'encoders.get': 'getEncoders',
	'encoders.update': 'updateEncoders',
	'encoders.add': 'addEncoders',
	'encoders.delete': 'deleteEncoders',
	'encoders.abort': 'abortEncoders',
	'encoders.update_version': 'deleteEncoders', // todo: switch to unique capability
	'encoders.restart': 'restartEncoders',
	'encoders.move': 'moveEncoders',
	'encoders.cpu_usage': 'deleteEncoders', // todo: switch to unique capability
	'encoders.capture_card': 'getEncodersLogs', // todo: switch to unique capability
	'encoders.view_logs': 'getEncodersLogs',
	'encoders.upload_logs': 'uploadEncodersLogs',
	'encoders.update_network': 'updateEncodersNetwork',
	'encoders.lan_mode.get': 'updateEncodersLanMode',
	'encoders.lan_mode.update': 'updateEncodersLanMode',
	'encoders.input.update': 'updateEncodersInput',

	'uploaders.delete': 'deleteUploaders',

	'encoder_profiles.get': 'getEncoderProfiles',
	'encoder_profiles.update': 'updateEncoderProfiles',
	'encoder_profiles.add': 'addEncoderProfiles',
	'encoder_profiles.delete': 'deleteEncoderProfiles',
	'encoder_profiles.options.get': 'deleteEncoderProfiles', // todo: switch to unique capability
	'encoder_profiles.options.update': 'deleteEncoderProfiles', // todo: switch to unique capability

	'web_encoder_profiles.get': 'getWebEncoderProfiles',
	'web_encoder_profiles.update': 'updateWebEncoderProfiles',
	'web_encoder_profiles.add': 'addWebEncoderProfiles',
	'web_encoder_profiles.delete': 'deleteWebEncoderProfiles',

	'events.get': 'getEvents',
	'events.update': 'updateEvents',
	'events.add': 'addEvents',
	'events.delete': 'deleteEvents',
	'events.start_transcoding': 'startTranscoder',

	'web_events.get': 'getTranscodedEvents',
	'web_events.update': 'updateTranscodedEvents',
	'web_events.delete': 'deleteTranscodedEvents',

	'campus_review.get': 'getCampusReview',

	'cues.get': 'getCues',
	'cues.update': 'updateCues',
	'cues.add': 'addCues',
	'cues.delete': 'deleteCues',

	// social media accounts
	'social_accts.get': 'getSocialMedia',
	'social_accts.update': 'updateSocialMedia',
	'social_accts.add': 'addSocialMedia',
	'social_accts.delete': 'deleteSocialMedia',
	// social media schedules & events
	'social_media.get': 'getSocialMediaEvents',
	'social_media.update': 'updateSocialMediaEvents',
	'social_media.add': 'addSocialMediaEvents',
	'social_media.delete': 'deleteSocialMediaEvents',
	'social_media.publish': 'addSocialMediaEvents',

	'event_profiles.get': 'getEventProfiles',
	'event_profiles.update': 'updateEventProfiles',
	'event_profiles.add': 'addEventProfiles',
	'event_profiles.delete': 'deleteEventProfiles',
	'event_profiles.lan_only': 'deleteEventProfiles', // todo: switch to unique capability
	'event_profiles.view_bucket': 'deleteEventProfiles', // todo: switch to unique capability
	'event_profiles.users.get': 'getEventProfileUsers',
	'event_profiles.users.update': 'updateEventProfiles',
	'event_profiles.users.add': 'addEventProfileUsers',
	// todo: eventually switch to addEventProfiles or unique; should remain LA1 for now; when we release to customers
	// the auto complete field should be switched with a dropdown (they shouldn't have to know what orgs are shared to them)
	'event_profiles.users.add_by_org': 'deleteEventProfiles',
	'event_profiles.users.delete': 'deleteEventProfileUsers',

	'web_event_profiles.get': 'getTranscodedEventProfiles',
	'web_event_profiles.update': 'updateTranscodedEventProfiles',
	'web_event_profiles.add': 'addTranscodedEventProfiles',
	'web_event_profiles.delete': 'deleteTranscodedEventProfiles',
	'web_event_profiles.update_persistent_urls': 'deleteTranscodedEventProfiles', // todo: switch to unique capability
	'web_event_profiles.bandwidth_usage': 'getWebEventProfileUsage',
	'web_event_profiles.bandwidth_cost': 'getWebEventProfileCost',

	'schedules.get': 'getSchedules',
	'schedules.update': 'updateSchedules',
	'schedules.add': 'addSchedules',
	'schedules.delete': 'deleteSchedules',

	'transcoder_schedules.get': 'getTranscodedEventSchedules',
	'transcoder_schedules.update': 'updateTranscodedEventSchedules',
	'transcoder_schedules.add': 'addTranscodedEventSchedules',
	'transcoder_schedules.delete': 'deleteTranscodedEventSchedules',

	'users.get': 'getUsers',
	'users.update': 'updateUsers',
	'users.add': 'addUsers',
	'users.delete': 'deleteUsers',
	'users.billing': 'updateUsersBilling',
	'users.decoder_status': 'addUsers', // User's decoder status (which really shouldn't be available since they shouldn't login to decoder)
	'users.player_logs': 'getPlayerLogs',

	'invited_users.get': 'getUserInvites',
	'invited_users.add': 'addUserInvites',
	'invited_users.resend': 'resendUserInvites',
	'invited_users.revoke': 'revokeUserInvites',

	'contacts.get': 'getContacts',
	'contacts.update': 'updateContacts',
	'contacts.add': 'addContacts',
	'contacts.delete': 'deleteContacts',
	'contacts.import': 'deleteCustomers', // la1 only

	'contact_search.get': 'deleteCustomers',

	'monitor.get': 'deleteCustomers',

	'customers.get_all': 'getCustomers',
	'customers.get_one': 'getCustomer',
	'customers.update': 'updateCustomers',
	'customers.add': 'addCustomers',
	'customers.delete': 'deleteCustomers',

	'toggles.view': 'getCustomers',
	'toggles.update': 'addCustomers',

	'orders.get': 'getHardwareOrders',
	'hardware_units.dashboard': 'getHardwareDashboard',
	'hardware_units.get': 'getHardware',
	'hardware_options.get': 'getHardware',
	'hardware_options.update': 'updateHardwareOptions',

	'destination_groups.get': 'getDestinationGroups',
	'destination_groups.update': 'updateDestinationGroups',
	'destination_groups.add': 'addDestinationGroups',
	'destination_groups.delete': 'deleteDestinationGroups',
};
